/**
 * @file コンポーネント フル動画ページコンテンツ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// フック読み込み
import { useProhibit } from "~/src/hooks/prohibit";
import { useUserAgent } from "~/src/hooks/userAgent";

// コンポーネントを返す
export const Contents = () => {
    /**
     * 禁止ユーザー操作をセット
     */
    useProhibit();

    /**
     * ユーザーエージェントによるclassセット
     */
    useUserAgent();

    /**
     * ログインモーダル開閉管理（SEO対応）
     */
    const [isOpenModalLogin, setIsOpenModalLogin] = useState(false);

    return (
        <Presenter
            isOpenModalLogin={isOpenModalLogin}
            setIsOpenModalLogin={setIsOpenModalLogin}
        />
    );
};
